import { DefaultOptionType } from 'antd/lib/select';

export const filterSort = (optionA: DefaultOptionType, optionB: DefaultOptionType): number => {
  const { label: labelA } = optionA;
  const { label: labelB } = optionB;

  return (typeof labelA === 'string' || typeof labelA === 'number') &&
    (typeof labelB === 'string' || typeof labelB === 'number')
    ? labelA.toString().toLowerCase().localeCompare(labelB.toString().toLowerCase(), undefined, { numeric: true })
    : 0;
};
